import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, ImageDown, Loader2, RotateCcw } from "lucide-react";

const fmtEta = (m) => (m == null ? "—" : m < 60 ? `~${m} min` : `~${Math.floor(m / 60)} orë ${m % 60} min`);

export default function ImageMirrorCard() {
    const [s, setS] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/admin/images/mirror-status").then(({ data }) => setS(data)).catch(() => {});
    useEffect(() => {
        load();
        const id = setInterval(load, 15000);
        return () => clearInterval(id);
    }, []);

    const retry = async () => {
        setBusy(true);
        try { await api.post("/admin/images/mirror-retry"); await load(); } finally { setBusy(false); }
    };

    if (!s) return null;
    const pct = s.with_images ? Math.floor((s.done / s.with_images) * 100) : 100;

    return (
        <section className="border border-sky-200 p-4 mb-6 max-w-3xl" data-testid="image-mirror-card">
            <div className="flex items-center justify-between gap-3 mb-3">
                <div className="flex items-center gap-2 font-display font-black uppercase">
                    <ImageDown className="w-4 h-4" /> Kopjimi i fotove
                </div>
                {s.complete ? (
                    <span className="inline-flex items-center gap-1 text-xs font-mono text-emerald-700" data-testid="image-mirror-complete">
                        <CheckCircle2 className="w-4 h-4" /> Përfundoi
                    </span>
                ) : (
                    <span className="inline-flex items-center gap-1 text-xs font-mono text-slate-500" data-testid="image-mirror-state">
                        {s.running ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Në punë</> : "Në pritje (rinis vetë)"}
                    </span>
                )}
            </div>
            <div className="text-sm mb-2" data-testid="image-mirror-progress-text">
                <b>{s.done.toLocaleString()}</b> / {s.with_images.toLocaleString()} produkte i kanë fotot te ne
                <span className="text-slate-500"> · ende nga ee-turbo: {s.pending.toLocaleString()}</span>
            </div>
            <div className="h-2 bg-slate-200 mb-3" data-testid="image-mirror-progress-bar">
                <div className="h-full bg-[hsl(var(--primary))] transition-[width] duration-700" style={{ width: `${pct}%` }} />
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs font-mono text-slate-600">
                <span data-testid="image-mirror-percent">{pct}%</span>
                <span data-testid="image-mirror-rate">{s.rate_per_hour} produkte / orë</span>
                <span data-testid="image-mirror-mode">{s.night_mode ? "Regjimi i natës: i shpejtë (18:00–06:00)" : "Regjimi i ditës: i ngadaltë (i shpejtë 18:00–06:00)"}</span>
                <span data-testid="image-mirror-eta">Koha e mbetur: {s.complete ? "0" : fmtEta(s.eta_minutes)}</span>
                <span className={s.failed_images ? "text-red-600" : ""} data-testid="image-mirror-failed">
                    Dështuan: {s.failed_images} foto ({s.failed_products} produkte)
                </span>
                {s.failed_images > 0 && (
                    <button onClick={retry} disabled={busy} className="btn-outline !py-1 !text-[10px]" data-testid="image-mirror-retry">
                        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <RotateCcw className="w-3 h-3" />} Provo përsëri
                    </button>
                )}
            </div>
        </section>
    );
}
